module.exports = __webpack_public_path__ + "static/media/p2008park.2c863897.jpg";